export default __webpack_public_path__ + "static/media/LLNL.7df75b67.png";